var R=Symbol("ABORT_ERROR"),E=Symbol("RESPONSE_ERROR"),O=Symbol("FETCH_ERROR"),S=Symbol("TIMEDOUT_ERROR");export{R as ABORT_ERROR,O as FETCH_ERROR,E as RESPONSE_ERROR,S as TIMEDOUT_ERROR};
//# sourceMappingURL=constants.js.map
